import React from 'react';
import { Calendar, CheckCircle, MessageSquare, Shield, MapPin } from 'lucide-react';

const TrustPointsSection = ({ data }) => {
  const trustPoints = [
    { icon: Calendar, label: "Fixed schedules", outcome: "(no missed cleans)" },
    { icon: CheckCircle, label: "Reliable attendance", outcome: "(no chasing)" },
    { icon: MessageSquare, label: "Clear communication", outcome: "(one point of contact)" },
    { icon: Shield, label: "Fully insured", outcome: "(Public, Employer's & Professional Indemnity)" },
    { icon: MapPin, label: "Local service area", outcome: "(North & Greater London)" }
  ];

  return (
    <section className="px-5 sm:px-6 py-14 md:py-20 bg-[#f9fafb]">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-gray-900 text-center mb-3">
          {data.title}
        </h2>
        
        {/* Experience Sub-headline */}
        <p className="text-center text-gray-600 text-base sm:text-lg mb-10 leading-relaxed">
          Over 4 years maintaining managed residential blocks across London.
        </p>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
          {trustPoints.map((point, index) => {
            const IconComponent = point.icon;
            return (
              <div 
                key={index} 
                className="flex items-start gap-3 p-4 bg-white rounded-xl shadow-[0_1px_3px_rgba(0,0,0,0.06),0_1px_2px_rgba(0,0,0,0.04)] border border-gray-100/80"
              >
                <IconComponent className="w-5 h-5 text-[#00c853] flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                <div className="leading-snug">
                  <span className="text-gray-800 font-medium text-sm sm:text-base">{point.label}</span>
                  <span className="text-gray-500 text-xs sm:text-sm ml-1">{point.outcome}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustPointsSection;
